// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: int_hotel.proto

/* eslint-disable */
import { SearchSource, searchSourceFromJSON, searchSourceToJSON } from "./common_enum";
import { RoomInt } from "./room_int";

export const protobufPackage = "usertracking.v3";

export interface IntHotel {
  date_from: string;
  date_to: string;
  city: string;
  city_id: number;
  hotel: string;
  hotel_id: number;
  utm_source: string;
  sort: string;
  rooms_no: number;
  adults_no: number;
  child_no: number;
  rooms: RoomInt[];
  price: number;
  shop_random_id: string;
  booking_id: number;
  pe_rule_id: number;
  final_price: number;
  book_price: number;
  payment_gateway: string;
  amount: number;
  discount_code: string;
  error: string;
  discount: number;
  payment_success: boolean;
  is_available: boolean;
  price_off: number;
  discount_percent: number;
  page: number;
  available_hotels_id: number[];
  available_rooms_id: number[];
  ih_available_rooms_no: number;
  eligible_payment_gateways: string[];
  gateway: string;
  search_source: SearchSource;
  basket_price: number;
  ycard_balance: number;
  penny_balance: number;
}

function createBaseIntHotel(): IntHotel {
  return {
    date_from: "",
    date_to: "",
    city: "",
    city_id: 0,
    hotel: "",
    hotel_id: 0,
    utm_source: "",
    sort: "",
    rooms_no: 0,
    adults_no: 0,
    child_no: 0,
    rooms: [],
    price: 0,
    shop_random_id: "",
    booking_id: 0,
    pe_rule_id: 0,
    final_price: 0,
    book_price: 0,
    payment_gateway: "",
    amount: 0,
    discount_code: "",
    error: "",
    discount: 0,
    payment_success: false,
    is_available: false,
    price_off: 0,
    discount_percent: 0,
    page: 0,
    available_hotels_id: [],
    available_rooms_id: [],
    ih_available_rooms_no: 0,
    eligible_payment_gateways: [],
    gateway: "",
    search_source: SearchSource.search_box,
    basket_price: 0,
    ycard_balance: 0,
    penny_balance: 0,
  };
}

export const IntHotel: MessageFns<IntHotel> = {
  fromJSON(object: any): IntHotel {
    return {
      date_from: isSet(object.date_from) ? globalThis.String(object.date_from) : "",
      date_to: isSet(object.date_to) ? globalThis.String(object.date_to) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      city_id: isSet(object.city_id) ? globalThis.Number(object.city_id) : 0,
      hotel: isSet(object.hotel) ? globalThis.String(object.hotel) : "",
      hotel_id: isSet(object.hotel_id) ? globalThis.Number(object.hotel_id) : 0,
      utm_source: isSet(object.utm_source) ? globalThis.String(object.utm_source) : "",
      sort: isSet(object.sort) ? globalThis.String(object.sort) : "",
      rooms_no: isSet(object.rooms_no) ? globalThis.Number(object.rooms_no) : 0,
      adults_no: isSet(object.adults_no) ? globalThis.Number(object.adults_no) : 0,
      child_no: isSet(object.child_no) ? globalThis.Number(object.child_no) : 0,
      rooms: globalThis.Array.isArray(object?.rooms) ? object.rooms.map((e: any) => RoomInt.fromJSON(e)) : [],
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      shop_random_id: isSet(object.shop_random_id) ? globalThis.String(object.shop_random_id) : "",
      booking_id: isSet(object.booking_id) ? globalThis.Number(object.booking_id) : 0,
      pe_rule_id: isSet(object.pe_rule_id) ? globalThis.Number(object.pe_rule_id) : 0,
      final_price: isSet(object.final_price) ? globalThis.Number(object.final_price) : 0,
      book_price: isSet(object.book_price) ? globalThis.Number(object.book_price) : 0,
      payment_gateway: isSet(object.payment_gateway) ? globalThis.String(object.payment_gateway) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      discount_code: isSet(object.discount_code) ? globalThis.String(object.discount_code) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      discount: isSet(object.discount) ? globalThis.Number(object.discount) : 0,
      payment_success: isSet(object.payment_success) ? globalThis.Boolean(object.payment_success) : false,
      is_available: isSet(object.is_available) ? globalThis.Boolean(object.is_available) : false,
      price_off: isSet(object.price_off) ? globalThis.Number(object.price_off) : 0,
      discount_percent: isSet(object.discount_percent) ? globalThis.Number(object.discount_percent) : 0,
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      available_hotels_id: globalThis.Array.isArray(object?.available_hotels_id)
        ? object.available_hotels_id.map((e: any) => globalThis.Number(e))
        : [],
      available_rooms_id: globalThis.Array.isArray(object?.available_rooms_id)
        ? object.available_rooms_id.map((e: any) => globalThis.Number(e))
        : [],
      ih_available_rooms_no: isSet(object.ih_available_rooms_no) ? globalThis.Number(object.ih_available_rooms_no) : 0,
      eligible_payment_gateways: globalThis.Array.isArray(object?.eligible_payment_gateways)
        ? object.eligible_payment_gateways.map((e: any) => globalThis.String(e))
        : [],
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      search_source: isSet(object.search_source) ? searchSourceFromJSON(object.search_source) : SearchSource.search_box,
      basket_price: isSet(object.basket_price) ? globalThis.Number(object.basket_price) : 0,
      ycard_balance: isSet(object.ycard_balance) ? globalThis.Number(object.ycard_balance) : 0,
      penny_balance: isSet(object.penny_balance) ? globalThis.Number(object.penny_balance) : 0,
    };
  },

  toJSON(message: IntHotel): unknown {
    const obj: any = {};
    if (message.date_from !== "") {
      obj.date_from = message.date_from;
    }
    if (message.date_to !== "") {
      obj.date_to = message.date_to;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.city_id !== 0) {
      obj.city_id = Math.round(message.city_id);
    }
    if (message.hotel !== "") {
      obj.hotel = message.hotel;
    }
    if (message.hotel_id !== 0) {
      obj.hotel_id = Math.round(message.hotel_id);
    }
    if (message.utm_source !== "") {
      obj.utm_source = message.utm_source;
    }
    if (message.sort !== "") {
      obj.sort = message.sort;
    }
    if (message.rooms_no !== 0) {
      obj.rooms_no = Math.round(message.rooms_no);
    }
    if (message.adults_no !== 0) {
      obj.adults_no = Math.round(message.adults_no);
    }
    if (message.child_no !== 0) {
      obj.child_no = Math.round(message.child_no);
    }
    if (message.rooms?.length) {
      obj.rooms = message.rooms.map((e) => RoomInt.toJSON(e));
    }
    if (message.price !== 0) {
      obj.price = Math.round(message.price);
    }
    if (message.shop_random_id !== "") {
      obj.shop_random_id = message.shop_random_id;
    }
    if (message.booking_id !== 0) {
      obj.booking_id = Math.round(message.booking_id);
    }
    if (message.pe_rule_id !== 0) {
      obj.pe_rule_id = Math.round(message.pe_rule_id);
    }
    if (message.final_price !== 0) {
      obj.final_price = Math.round(message.final_price);
    }
    if (message.book_price !== 0) {
      obj.book_price = Math.round(message.book_price);
    }
    if (message.payment_gateway !== "") {
      obj.payment_gateway = message.payment_gateway;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.discount_code !== "") {
      obj.discount_code = message.discount_code;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.discount !== 0) {
      obj.discount = Math.round(message.discount);
    }
    if (message.payment_success !== false) {
      obj.payment_success = message.payment_success;
    }
    if (message.is_available !== false) {
      obj.is_available = message.is_available;
    }
    if (message.price_off !== 0) {
      obj.price_off = Math.round(message.price_off);
    }
    if (message.discount_percent !== 0) {
      obj.discount_percent = Math.round(message.discount_percent);
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.available_hotels_id?.length) {
      obj.available_hotels_id = message.available_hotels_id.map((e) => Math.round(e));
    }
    if (message.available_rooms_id?.length) {
      obj.available_rooms_id = message.available_rooms_id.map((e) => Math.round(e));
    }
    if (message.ih_available_rooms_no !== 0) {
      obj.ih_available_rooms_no = Math.round(message.ih_available_rooms_no);
    }
    if (message.eligible_payment_gateways?.length) {
      obj.eligible_payment_gateways = message.eligible_payment_gateways;
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.search_source !== SearchSource.search_box) {
      obj.search_source = searchSourceToJSON(message.search_source);
    }
    if (message.basket_price !== 0) {
      obj.basket_price = Math.round(message.basket_price);
    }
    if (message.ycard_balance !== 0) {
      obj.ycard_balance = Math.round(message.ycard_balance);
    }
    if (message.penny_balance !== 0) {
      obj.penny_balance = Math.round(message.penny_balance);
    }
    return obj;
  },

  create(base?: DeepPartial<IntHotel>): IntHotel {
    return IntHotel.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntHotel>): IntHotel {
    const message = createBaseIntHotel();
    message.date_from = object.date_from ?? "";
    message.date_to = object.date_to ?? "";
    message.city = object.city ?? "";
    message.city_id = object.city_id ?? 0;
    message.hotel = object.hotel ?? "";
    message.hotel_id = object.hotel_id ?? 0;
    message.utm_source = object.utm_source ?? "";
    message.sort = object.sort ?? "";
    message.rooms_no = object.rooms_no ?? 0;
    message.adults_no = object.adults_no ?? 0;
    message.child_no = object.child_no ?? 0;
    message.rooms = object.rooms?.map((e) => RoomInt.fromPartial(e)) || [];
    message.price = object.price ?? 0;
    message.shop_random_id = object.shop_random_id ?? "";
    message.booking_id = object.booking_id ?? 0;
    message.pe_rule_id = object.pe_rule_id ?? 0;
    message.final_price = object.final_price ?? 0;
    message.book_price = object.book_price ?? 0;
    message.payment_gateway = object.payment_gateway ?? "";
    message.amount = object.amount ?? 0;
    message.discount_code = object.discount_code ?? "";
    message.error = object.error ?? "";
    message.discount = object.discount ?? 0;
    message.payment_success = object.payment_success ?? false;
    message.is_available = object.is_available ?? false;
    message.price_off = object.price_off ?? 0;
    message.discount_percent = object.discount_percent ?? 0;
    message.page = object.page ?? 0;
    message.available_hotels_id = object.available_hotels_id?.map((e) => e) || [];
    message.available_rooms_id = object.available_rooms_id?.map((e) => e) || [];
    message.ih_available_rooms_no = object.ih_available_rooms_no ?? 0;
    message.eligible_payment_gateways = object.eligible_payment_gateways?.map((e) => e) || [];
    message.gateway = object.gateway ?? "";
    message.search_source = object.search_source ?? SearchSource.search_box;
    message.basket_price = object.basket_price ?? 0;
    message.ycard_balance = object.ycard_balance ?? 0;
    message.penny_balance = object.penny_balance ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
